export const PARAM_LODGING_ID = "lodgingId";
export const PARAM_FROM_DATE = "fromDate";
export const PARAM_UNTIL_DATE = "untilDate";
export const PARAM_ADULTS_COUNT = "adultsCount";
export const PARAM_CHILDREN = "children";
export const PARAM_ROOMS_COUNT = "roomsCount";
export const PARAM_PETS_COUNT = "petsCount";
export const PARAM_SELECTED_ACCOUNT_INDEX = "selectedAccountIndex";
export const PARAM_SELECTED_LODGING_INDEX = "selectedLodgingIndex";
export const PARAM_LODGING_SELECTION = "lodgingSelection";
export const PARAM_FROM_HOTEL_AVAILABILITY = "fromHotelAvailability";
export const PARAM_ENTRY_POINT = "entryPoint";
export const PARAM_PREFERENCES_RECOMMENDED = "preferencesRecommended";
export const PARAM_HOTEL_DETAILS_ENTRY_SOURCE = "hotelDetailsEntrySource";
export const PARAM_SHOP_TOKEN = "shopToken";
export const PARAM_SORT_ORDER = "sortOrder";

export const LODGING_SELECTION_TYPE = "LodgingSelection";
export const LODGING_IDS = "lodgingIds";
export const PRESERVE_ORDER = "preserveOrder";
